import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import input from "./src/input.vue";
import searchMore from "./src/search-more.vue";
import inputAffix from "./src/input-affix.vue";
export const xInput = withInstall(input, { searchMore, inputAffix });
export const xInputSearchMore = withNoopInstall(searchMore);
export const xInputAffix = withNoopInstall(inputAffix);
export default xInput;
export * from "./src/search-more";
export * from "./src/input";
